import { useState } from 'react';
import { useRouter } from 'next/router';
import { LayoutGroup } from 'framer-motion';
import cn from 'classnames';
import { NextLink } from '~/i18n';
import { CheckGreenIcon } from '~/svgs/marketplace';
import { useAuth } from '~/auth';
import { ActionPreventedAlert } from '~/components/common/alert/action-prevented';
interface menuItemsType {
   links: {
      href: string;
      text: React.ReactNode;
      description?: React.ReactNode;
      isComplete?: boolean;
      needsReview?: boolean;
      hideInternational?: boolean;
   }[];
   isSteps?: boolean;
}

export const SubMenu = ({ links, isSteps }: menuItemsType) => {
   const router = useRouter();
   const { user } = useAuth();
   const [showPrevent, setShowPrevent] = useState(false);

   const closePrevent = () => setShowPrevent(false);

   const handleUnderReviewClick = (e: any, prevent: boolean) => {
      if (prevent) {
         e.preventDefault();
         setShowPrevent(true);
      }
   };

   const filteredLinks = links.filter(item => !(user.international && item.hideInternational));

   return (
      <LayoutGroup>
         <ActionPreventedAlert open={showPrevent} onClose={closePrevent} />
         {!isSteps ? (
            <ul className="text-sm  rounded-lg my-10 bg-white shadow-md">
               {filteredLinks?.map(({ href, text, description, needsReview }) => {
                  const active = router.pathname === `/[lang]${href.replace(':id', '[id]')}`;
                  const underReview =
                     user?.profile_strength &&
                     (!user?.profile_strength?.has_business_profile || !user?.uploaded_legal_docs);
                  const notReviewed = (needsReview && underReview) || false;
                  return (
                     <li key={href} className="border-b last:border-b-0 border-gray-100">
                        <div className="flex justify-between items-center relative">
                           <NextLink
                              onClick={(e: any) => handleUnderReviewClick(e, notReviewed)}
                              exact
                              href={href}
                              className="pl-3 pr-2 peer py-3 w-full text-black font-semibold"
                              activeClassName="text-primary !font-bold">
                              <div>
                                 <span>{text}</span> <br />
                                 <span className="text-xs text-grey-100 font-[400] opacity-70">
                                    {description}
                                 </span>
                              </div>
                              {active ? (
                                 <div className="w-1 h-[45px] absolute ltr:left-0 rtl:right-0 top-1 mt-1.5 ltr:border-l-[3px] rtl:border-r-[3px] border-primary"></div>
                              ) : null}
                           </NextLink>
                        </div>
                     </li>
                  );
               })}
            </ul>
         ) : (
            <ul className="relative overflow-hidden text-sm my-5">
               <div className="absolute border-dashed border-r border-primary h-full ltr:ml-4 rtl:mr-2"></div>
               {filteredLinks?.map(({ href, text, description, isComplete }, index) => {
                  const active = router.pathname.startsWith(
                     `/[lang]${href.replace(':id', '[id]')}`
                  );

                  return (
                     <li key={href} className="mb-5 last:mb-0">
                        <div className="flex justify-between text-lg relative">
                           <div
                              className={cn(
                                 'p-3 peer w-full rounded z-20 bg-[#f8f8f8]',
                                 active && !isComplete && 'text-lg !bg-white'
                              )}>
                              <div>
                                 {isComplete ? (
                                    <CheckGreenIcon className="w-4 -ml-0.5 mb-2" />
                                 ) : (
                                    <div
                                       className={cn(
                                          'flex items-center justify-center text-[10px] font-bold  w-4 h-4 text-primary rounded-full bg-[#dcf0f0] border border-dashed border-primary -ml-0.5 mb-2',
                                          active && !isComplete && 'border-none -mt-1.5'
                                       )}>
                                       {index + 1}
                                    </div>
                                 )}
                                 <div className="flex flex-col">
                                    <span
                                       className={cn(
                                          'font-normal',
                                          (active || isComplete) && '!font-bold',
                                          isComplete && 'text-green'
                                       )}>
                                       {text}
                                    </span>{' '}
                                    <span className="text-xs text-grey-300">{description}</span>
                                 </div>
                              </div>
                              {active && !isComplete ? (
                                 <div className="w-1 h-[45px] absolute ltr:left-0 rtl:right-0 top-3 mt-1.5 ltr:border-l-[3px] rtl:border-r-[3px] border-primary"></div>
                              ) : null}
                           </div>
                        </div>
                     </li>
                  );
               })}
            </ul>
         )}
      </LayoutGroup>
   );
};
